module.exports = __webpack_public_path__ + "img/companylogo.121d2b15.webp";